<form class="access-settings-form" [formGroup]="form">
  <div class="switch-field">
    Отчёт виден всем
    <p-inputSwitch formControlName="isPublic" (onChange)="onChangeIsPublic($event)"></p-inputSwitch>
  </div>
</form>

@if (!isPublicValue) {
<app-table
  [options]="tableOptions"
  [addDialogTmpRef]="addTemplate"
  [columnsTemplates]="{
    isEnabled: statusTmp
  }"
  (onInitialized)="onInitTable($event)"
></app-table>

<ng-template #addTemplate>
  <add-form [excludeUUIDs]="grantedUsersValue" (valueChange)="addSelectedUUIDsChange($event)"></add-form>
</ng-template>

<ng-template #statusTmp let-value="value">
  <users-status [value]="value"></users-status>
</ng-template>
}

<p-dialog [header]="'Подтверждение действия'" [modal]="true" [(visible)]="confirmDialogVisible">
  <div>Вы действительно хотите предоставить доступ к этому отчёту всем пользователям?</div>

  <ng-template pTemplate="footer">
    <p-button type="button" [label]="'Да'" (click)="confirmDialogResult(true)" />
    <p-button type="button" [outlined]="true" [label]="'Нет'" (click)="confirmDialogResult(false)" />
  </ng-template>
</p-dialog>
